import { WordsEmptyState } from '@/components/words/words-empty-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/words/')({
  component: WordsIndexPage,
});

function WordsIndexPage() {
  return <WordsEmptyState />;
}
